import * as api from '../api'
import { CREATE_GAMEFACT, DELETE_GAMEFACT, UPDATE_GAMEFACT } from '../constants/actionTypes.js'

export const createGameFact = (gameFact, type, match, morePayload = {}) => async (dispatch, getState) => {
    try {

        const newGameFact = {}
        newGameFact.detail = gameFact
        newGameFact.creation = Date.now()
        newGameFact.idMatch = match.idMatch
        newGameFact.type = type
        newGameFact.detail.period = gameFact.period !== undefined ? gameFact.period : match.period
        newGameFact.detail.edited = false

        newGameFact.idLive = getState().live._id

        const { data } = await api.createGameFact({...newGameFact, ...morePayload})

        console.log('created gamefact', data);

        return data;

        //dispatch( { type : CREATE_GAMEFACT, payload: data })
    } catch(error){
        console.log(error)
        throw error;
    }
}

export const updateGameFact = (gameFactDetail, id) => async (dispatch, getState) => {
    try {
        const { data } = await api.updateGameFact(id, {...gameFactDetail, edited : false})

        console.log('updated gamefact', data);

        return data;

       // dispatch({ type : UPDATE_GAMEFACT, payload: data})
    } catch(error){
        console.log(error)
        throw error
    }
}

export const deleteGameFact = (id) => async (dispatch) => {
    try {
        await api.deleteGameFact(id)

        //dispatch({ type : DELETE_GAMEFACT, payload: id})
    }catch(error){
        console.log(error)
    }
}